<template>
    <div>
        <ModalCommon id="ModalListTemplateMailI" :config="configModal" @close="handleClose()" :isView="true">
            <div v-if="isUpdate" class="d-flex justify-content-center">
                <LoadingIcon />
            </div>
            <template v-else>
                <div class="table-responsive" v-if="!isEdit" style="max-height: 80vh">
                    <table class="table table-bordered table-box table-hover table-resize">
                        <thead>
                            <tr>
                                <th class="position-sticky" style="width: 40px; top: 0; z-index: 20; background-color: #f4f4f4">ID</th>
                                <th class="position-sticky" style="width: 500px; top: 0; z-index: 20; background-color: #f4f4f4">
                                    {{ $t('managerForm.temporarily.nameTemp') }}
                                </th>
                                <th class="position-sticky" style="width: 150px; top: 0; z-index: 20; background-color: #f4f4f4"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(temp, idx) in listTemplateMail" :key="idx">
                                <td class="el-table__cell text-left">{{ listTemplateMail.length - idx }}</td>
                                <td class="el-table__cell text-left">{{ temp.template_name }}</td>
                                <td class="sticky_action text-center" style="z-index: 14">
                                    <div class="row-data-small">
                                        <div class="d-flex flex-wrap">
                                            <a href="javascript:void(0)" class="btn btn-common-sml btn-primary mr-2" @click="goToEdit(temp)"
                                                ><i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}</a
                                            >
                                            <a href="javascript:void(0)" class="btn btn-common-sml btn-danger mr-2" @click="onDelete(temp)"
                                                ><i class="ri-delete-bin-line"></i>{{ $t('btn.delete') }}</a
                                            >
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <template v-else>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 150px"
                            >{{ $t('managerForm.settingPage.pageTypeI.invite.templateName') }}
                            <span v-if="onHandleCheckFieldRequired(configField.template_name.typesValidate)" class="text-danger">*</span></label
                        >
                        <div class="col-sm-9">
                            <InputText
                                :model.sync="formInit.template_name"
                                :config.sync="configField.template_name"
                                @blur="handleValidateField(formInit.template_name, configField.template_name)"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 150px"
                            >{{ $t('managerForm.settingPage.pageTypeI.invite.emailSubject') }}
                            <span v-if="onHandleCheckFieldRequired(configField.subject.typesValidate)" class="text-danger">*</span></label
                        >
                        <div class="col-sm-9">
                            <InputText
                                :model.sync="formInit.subject"
                                :config.sync="configField.subject"
                                @blur="handleValidateField(formInit.subject, configField.subject)"
                            />
                        </div>
                    </div>
                    <!-- <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 150px"
                            >{{ $t('managerForm.settingPage.pageTypeI.invite.senderEmail') }}
                            <span v-if="onHandleCheckFieldRequired(configField.email_sender.typesValidate)" class="text-danger">*</span></label
                        >
                        <div class="col-sm-9">
                            <Multiselect
                                :id="`select-send-from-list-template`"
                                :value.sync="formInit.email_sender"
                                :options="listSenderMail"
                                :config.sync="configField.email_sender"
                            />
                        </div>
                    </div> -->
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 150px"
                            >{{ $t('managerForm.settingPage.pageTypeI.emailFormat') }}
                        </label>
                        <div class="col-sm-9">
                            <div class="d-flex">
                                <div v-for="item in optionSendType" :key="item.id">
                                    <InputRadio
                                        class="mr-4"
                                        :model.sync="formInit.type"
                                        :name="`list-template-sendType`"
                                        :id="`list-template-sendType-${item.id}`"
                                        :value="item.value"
                                        :label="item.label"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 150px"
                            >{{
                                configModal.typeTemplate === TYPE_TEMPLATE.INVITE
                                    ? $t('managerForm.settingPage.pageTypeI.invite.emailBody')
                                    :  '',
                            }}
                            <span v-if="onHandleCheckFieldRequired(configField.body.typesValidate)" class="text-danger">*</span></label
                        >
                        <div class="col-sm-9">
                            <TextareaComponent
                                :model.sync="formInit.body"
                                :rows="`12`"
                                :config.sync="configField.body"
                                @blur="handleValidateField(formInit.body, configField.body)"
                            >
                                <div v-if="configField.body.error" class="d-block invalid-feedback">
                                    <span>
                                        {{ configField.body.errorCustomMess }}
                                    </span>
                                </div>
                            </TextareaComponent>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center" style="gap: 1rem">
                        <button type="button" class="btn btn-common-cancel" @click="onCancel">{{ $t('btn.cancel') }}</button>
                        <button type="button" class="btn btn-common btn-success" @click="onSave">{{ $t('btn.save') }}</button>
                    </div>
                </template>
            </template>
        </ModalCommon>
    </div>
</template>

<script>
import ModalCommon from '@/components/Modal/main.vue';
// import Multiselect from '@/components/Multiselect/main.vue';
import TextareaComponent from '@/components/Textarea/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';

import { InputText, InputRadio } from '@/components/Input';
import { validateField, validateAllField } from '@/utils/validate_v2';
import { onHandleCheckFieldRequired, onHandleShowConfirm } from '@/utils/handlers';
import { managerFormMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import { TYPE_TEMPLATE, optionSendType } from './constants-mail';

export default {
    name: 'ModalListTemplateMailI',
    components: {
        ModalCommon,
        InputText,
        // Multiselect,
        TextareaComponent,
        LoadingIcon,
        InputRadio
    },
    props: {
        listTemplateMail: {
            type: Array,
            default: () => []
        },
        listSenderMail: {
            type: Array,
            default: () => []
        },
        configModal: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            TYPE_TEMPLATE,
            optionSendType,
            formInit: this.initialForm(),
            configField: this.fieldConfig(),
            isEdit: false,
            isUpdate: false
        };
    },
    methods: {
        ...managerFormMethods,
        onHandleCheckFieldRequired,
        initialForm() {
            return {
                subject: '',
                email_sender: null,
                type: 'text',
                body: ''
            };
        },

        fieldConfig(typeTemplate = null) {
            let typeValidBody = ['maxCustom'];
            if (typeTemplate === TYPE_TEMPLATE.INVITE) {
                typeValidBody.unshift('requiredCustomMsg');
            }
            return {
                template_name: {
                    error: false,
                    errorField: this.$t('managerForm.settingPage.pageTypeI.invite.templateName'),
                    typesValidate: ['required', 'max255']
                },
                subject: {
                    error: false,
                    errorField: this.$t('managerForm.settingPage.pageTypeI.invite.emailSubject'),
                    typesValidate: ['required', 'max255']
                },
                email_sender: {
                    trackBy: 'id',
                    label: 'label_mail',
                    error: false,
                    isRemove: true,
                    typesValidate: []
                },
                body: {
                    error: false,
                    length: 3000,
                    errorField: typeTemplate === TYPE_TEMPLATE.INVITE ? this.$t('managerForm.settingPage.pageTypeI.invite.emailBody') : '',
                    typesValidate: typeValidBody
                }
            };
        },

        handleClose() {
            this.onCancel();
            this.model = false;
        },

        handleValidateField(valueField, configField) {
            validateField(valueField, configField);
        },

        goToEdit(row) {
            this.formInit = {
                ...this.formInit,
                ...row,
                email_sender: row.email_sender ? this.listSenderMail.find((item) => item.id === row.email_sender.id) : null
            };
            this.configField = this.fieldConfig(this.configModal.typeTemplate);
            this.isEdit = true;
        },

        async onDelete(row) {
            const confirmDelete = await onHandleShowConfirm({
                title: 'このテンプレートを削除します。よろしいですか。',
                text: '',
                icon: 'warning',
                cancelButtonText: 'キャンセル'
            });
            if (confirmDelete) {
                this.isUpdate = true;
                try {
                    const resData = await this.deleteTemplateMail(row.id);
                    if (resData?.code !== 200) {
                        showMessage(resData.code, this.$bvToast, 'Lỗi khi xóa mẫu email');
                        return;
                    }
                    showMessage(resData.code, this.$bvToast, 'メールテンプレートを削除しました。');
                    this.$emit('refreshListTemplate', row.template_type);
                } catch (error) {
                    console.log('error', error);
                } finally {
                    this.isUpdate = false;
                }
            }
        },

        onCancel() {
            this.formInit = this.initialForm();
            this.configField = this.fieldConfig();
            this.isEdit = false;
        },

        async onSave() {
            let isCheckSave = validateAllField(this.formInit, this.configField);
            if (!isCheckSave) return isCheckSave;
            let payloadInit = this.formInit;
            let payloadUpdate = {
                id: payloadInit.id,
                data: {
                    subject: payloadInit.subject,
                    email_sender: {
                        id: payloadInit.email_sender ? payloadInit.email_sender.id : null,
                        email_address: payloadInit.email_sender ? payloadInit.email_sender.email_address : ''
                    },
                    body: payloadInit.body,
                    type: payloadInit.type,
                    template_name: payloadInit.template_name,
                    template_type: payloadInit.template_type
                }
            };
            if (this.isUpdate) return;
            this.isUpdate = true;
            try {
                const resData = await this.updateTemplateMail(payloadUpdate);
                if (resData?.code !== 200) {
                    showMessage(resData.code, this.$bvToast, 'Lỗi khi cập nhật mẫu email');
                    return;
                }
                showMessage(resData.code, this.$bvToast, 'メールテンプレートが更新されました。');
                this.isEdit = false;
                this.$emit('refreshListTemplate', payloadInit.template_type);
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isUpdate = false;
            }
        }
    },
    watch: {
        listTemplateMail: {
            async handler() {
                this.isUpdate = true;
                setTimeout(() => {
                    this.isUpdate = false;
                }, 400);
            },
            immediate: true,
            deep: true
        },
        isEdit: {
            handler(newVal) {
                if (newVal) {
                    this.configModal.title = 'テンプレート編集';
                } else {
                    this.configModal.title = this.$t('managerForm.ListTemporarily');
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
